import { put, takeLatest } from 'redux-saga/effects';
import { fetchIdSearchResults, setIdSearchResults, setIsSearchingIds, appNotify } from 'store/actions';
import { IdSearch } from 'api/revue/dashboard';

export function* idSearchSaga() {
  yield takeLatest(fetchIdSearchResults, function* ({ payload }) {
    const { idType, id } = payload;
    try {
      yield put(setIsSearchingIds(true));
      const results = yield IdSearch(idType, id);
      yield put(setIdSearchResults(results));
    } catch (error) {
      yield put(setIdSearchResults([]));
      yield put(appNotify(`Search failed: ${error.message}`, 'error'));
    } finally {
      yield put(setIsSearchingIds(false));
    }
  });
}
